import instance from "./endpoint";

//api to update password
export const changePassword = async ({ oldPassword, newPassword }) => {
    try {
      const response = await instance.put("/api/v1/auth/changePassword", {
        oldPassword,
        newPassword,
      });
      return response.data;
    } catch (error) {
      console.error("Error changing password:", error);
      throw error;
    }
  };


  // get profile
export const getProfile = async () => {
    const response = await instance.get("/api/v1/auth/profile", {});
    return response.data;
};

// update profile
export const updateProfile = async ({ FullName }) => {
    return await instance.put("/api/v1/auth/profile", {FullName});
};


// get kyc docs
export const getKycDocs = async () => {
    const response = await instance.get("/api/v1/kycproof/getDocument");
    return response.data;
};

//getBalance
export const getBalance = async () => {
    const response = await instance.get("/api/v1/account/balance");
    return response.data;
}


//getDeposits
export const getDeposits = async () => {
    const response = await instance.get("/api/v1/deposit/getApprovedDepositRequests");
    return response.data;
}

//getDeposits
export const getDepositHistory = async () => {
    const response = await instance.get("/api/v1/deposit");
    return response.data;
}

//payout history
export const getPayoutHistory = async () => {
    const response = await instance.get("/api/v1/withdraw");
    return response.data;
}


// get my referrals
export const getMyReferrals = async () => {
    const response = await instance.get("/api/v1/referrals/showmyreferrals");
    return response.data;
};

//get loan agreements (admin and superadmin)
export const getLoanAgreements = async () => {
    try {
        const response = await instance.get("api/v1/generateDoc/loanagreements");
        return response.data;
    } catch (error) {
        console.error("Error fetching loan agreements:", error);
        throw error;
    }
};
